import { IPutTeeSheetSettings } from "api/rpc/2024-04/facilityAdmin/facility/settings";
import Divider from "components/divider";
import FormLayout from "components/form/FormLayout";
import Input from "components/form/input/Input";
import { PreviewQRCode } from "components/previewQRCode/PreviewQRCode";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import React from "react";
import { useTranslation } from "react-i18next";
import "./facilitySettings.scss";

interface IProps {
  state: Partial<IPutTeeSheetSettings>;
  updateState: <K extends keyof IPutTeeSheetSettings>(key: K, value: IPutTeeSheetSettings[K]) => void;
}

export default function FacilityQRCodeSettings(props: IProps) {
  const { state, updateState } = props;
  const { t } = useTranslation();

  return (
    <div className="facility-settings-section p-2">
      <FormLayout>
        <FormLayout.Group>
          <Input
            label={t("Receipt URL")}
            type="text"
            id="receipts_url"
            value={state?.receipts_url}
            onChange={e => updateState("receipts_url", e.target?.value)}
            placeholder={t("Enter receipt URL...")}
          />
          <Input
            label={t("URL description")}
            type="text"
            id="receipts_url_description"
            value={state?.receipts_url_description}
            onChange={e => updateState("receipts_url_description", e.target?.value)}
            placeholder={t("Enter URL description...")}
          />
        </FormLayout.Group>
      </FormLayout>

      <div className="facility-settings-info-hint">
        <FontAwesomeIcon icon={faCircleInfo} className="facility-settings-info-hint-icon" />
        <p>
          {t(
            "Shows the URL and short description below the QR code on receipts, so customers know what the link is for.",
          )}
        </p>
      </div>

      <Divider />

      <p className="facility-settings-preview-label">{t("Preview")}</p>
      <div className="facility-settings-preview-qr">
        <PreviewQRCode receipts_url={state?.receipts_url} />
      </div>
    </div>
  );
}
